const movementTabsOptions = [
  { value: 'additions', label: 'Incorporaciones' },
  { value: 'exclusions', label: 'Exclusiones' }
];

export default movementTabsOptions;
